import React from "react";

import { socialMedia } from "data/links";

import Facebook from "core/jsSvgIcons/Facebook";
import Twitter from "core/jsSvgIcons/Twitter";
import Behance from "core/jsSvgIcons/Behance";
import Dribbble from "core/jsSvgIcons/Dribbble";
import Instagram from "core/jsSvgIcons/Instagram";

import { A } from "core/Typography";
import { Socials as StyledSocials, SocialsItem } from "./styles";

const iconComponent = {
    Facebook,
    Twitter,
    Behance,
    Dribbble,
    Instagram
};

export const Socials = () => (
    <StyledSocials>
        {socialMedia.map(link => {
            const { name, href } = link;

            const Icon = iconComponent[name];

            return (
                <SocialsItem key={name}>
                    <A href={href} alt={`Noun Project ${name}`} target="_blank">
                        <Icon title={`${name} logo`} />
                    </A>
                </SocialsItem>
            );
        })}
    </StyledSocials>
);
